import React from "react";
export default [
  {
    title: "گام ۱ : آشنایی با پنل کاربری تبلیغ دهنده های هایلایت",
    description:
      " در این ویدیو آموزشی به معرفی بخش ها و عناصر کاربردی در پنل کاربری تبلیغ دهنده های هایلایت می پردازیم.",
    iframe_src:
      "https://www.aparat.com/video/video/embed/videohash/O0uKp/vt/frame",
    link_PDF_file: "https://hilite.ir/wp-content/uploads/2023/01/familiar-to-panel-hilite-advertiser.pdf",
    link_web_page: "https://hilite.ir/learning/step-1-familiar-to-panel-hilite-advertiser",
  },
  {
    title: "گام ۲ : کمپین تبلیغاتی به چه معناست؟",
    description:
      "در این ویدیو آموزشی به بررسی مفهوم و معنای کمپین تبلیغاتی می پردازی",
    iframe_src:
      "https://www.aparat.com/video/video/embed/videohash/jYMJe/vt/frame",
    link_PDF_file: "https://hilite.ir/wp-content/uploads/2023/01/what-is-campaign-advertising.pdf",
    link_web_page: "https://hilite.ir/learning/step-2-what-is-campaign-advertising",
  },
  {
    title: "گام ۳ : نمایش دهنده ها،جایگاه تبلیغات و گروه نمایش دهنده",
    description:
      "در این ویدیو آموزشی به تعریف 3 عنصر اساسی در تبلیغات بنری هایلایت یعنی نمایش دهنده ها،جایگاه تبلیغات و گروه نمایش دهنده می پردازیم.",
    iframe_src:
      "https://www.aparat.com/video/video/embed/videohash/p162g/vt/frame",
    link_PDF_file: "https://hilite.ir/wp-content/uploads/2023/01/what-are-web-site-publishers-positions-and-category-user-site-publisher.pdf",
    link_web_page: "https://hilite.ir/learning/step-3-what-are-web-site-publishers-positions-and-category-user-site-publisher/",
  },
  {
    title: "گام ۴ : بررسی بخش نمایش دهنده های تبلیغات هایلایت",
    description:
      "در این ویدیو آموزشی به بررسی بخش نمایش دهنده های تبلیغات پلتفرم تبلیغات آنلاین هایلایت می پردازیم.",
    iframe_src:
      "https://www.aparat.com/video/video/embed/videohash/Rwcks/vt/frame",
    link_PDF_file: "https://hilite.ir/wp-content/uploads/2023/01/check-hilites-publishers-section.pdf",
    link_web_page: "https://hilite.ir/learning/step-4-check-hilites-publishers-section/",
  },
  {
    title: "گام ۵ : صفحات و جایگاه های نمایش دهنده تبلیغات ",
    description:
      "در این ویدیو آموزشی به بررسی صفحات نمایش دهنده تبلیغات و جایگاه های نمایش دهنده تبلیغات پلتفرم تبلیغات آنلاین هایلایت می پردازیم.",
    iframe_src:
      "https://www.aparat.com/video/video/embed/videohash/wUpta/vt/frame",
    link_PDF_file: "https://hilite.ir/wp-content/uploads/2023/01/pages-and-positions.pdf",
    link_web_page: "https://hilite.ir/learning/step-5-pages-and-positions",
  },
  {
    title: "گام ۶ : بررسی جدول اطلاعات جایگاه های نمایش تبلیغات هایلایت",
    description:
      "در این ویدیو آموزشی به بررسی جدول اطلاعات جایگاه های نمایش تبلیغات پلتفرم تبلیغات آنلاین هایلایت می پردازیم. هر جایگاه نمایش دهنده تبلیغات دارای مشخصه هایی می باشد که برای ایجاد کمپین تبلیغاتی موثر باید بدانید.",
    iframe_src:
      "https://www.aparat.com/video/video/embed/videohash/nqcUr/vt/frame",
    link_PDF_file: "https://hilite.ir/wp-content/uploads/2023/01/check-table-information-positions.pdf",
    link_web_page: "https://hilite.ir/learning/step-6-check-table-information-positions/",
  },
  {
    title: "گام ۷ : قوانین و چهارچوب گروه نمایش دهنده تبلیغات بنری",
    description:
      "در این ویدیو آموزشی به بررسی قوانین و چهارچوب گروه نمایش دهنده تبلیغات بنری پلتفرم تبلیغات آنلاین هایلایت می پردازیم.",
    iframe_src:
      "https://www.aparat.com/video/video/embed/videohash/4gPGu/vt/frame",
    link_PDF_file: "https://hilite.ir/wp-content/uploads/2023/01/rules-category-user-site-publisher.pdf",
    link_web_page: "https://hilite.ir/learning/step-7-rules-category-user-site-publisher/",
  },
  {
    title: "گام ۸ : ایجاد گروه نمایش دهنده تبلیغات بنری هایلایت",
    description:
      "در این ویدیو آموزشی به چگونگی ایجاد گروه نمایش دهنده تبلیغات بنری در پلتفرم تبلیغات آنلاین هایلایت می پردازیم.",
    iframe_src:
      "https://www.aparat.com/video/video/embed/videohash/uq9nt/vt/frame",
    link_PDF_file: "https://hilite.ir/wp-content/uploads/2023/01/create-category-user-site-publishe.pdf",
    link_web_page: "https://hilite.ir/learning/step-8-create-category-user-site-publisher/",
  },
  {
    title: "گام ۹ : ساخت کمپین تبلیغاتی بنری هایلایت",
    description:
      "در این ویدیو آموزشی به ساخت کمپین تبلیغاتی بنری در پلتفرم تبلیغات آنلاین هایلایت می پردازیم.",
    iframe_src:
      "https://www.aparat.com/video/video/embed/videohash/OfqV8/vt/frame",
    link_PDF_file: "https://hilite.ir/wp-content/uploads/2023/01/what-is-campaign-advertising.pdf",
    link_web_page: "https://hilite.ir/learning/step-9-create-campaign-advertising/",
  },
  {
    title: "گام ۱۰ : بررسی بخش تبلیغات و اضافه کردن تبیلغ به کمپین بنری",
    description:
      "در این ویدیو آموزشی به بررسی بخش تبلیغات و اضافه کردن بنر تبلیغاتی و یا محتوای تبلیغاتی به کمپین بنری در پلتفرم تبلیغات آنلاین هایلایت می پردازیم.",
    iframe_src:
      "https://www.aparat.com/video/video/embed/videohash/e4KhT/vt/frame",
    link_PDF_file: "https://hilite.ir/wp-content/uploads/2023/01/check-advertising-section-and-create-new-advertise.pdf",
    link_web_page: "https://hilite.ir/learning/step-10-check-advertising-section-and-create-new-advertise/",
  },
];
